"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renameDuplicateFileNames = void 0;
/**
 * Processes newly added docs, renaming them if there are already doc(s) with the same file name & extension.
 * The objects in the newDocs array are modified by this function.
 *
 * @param newDocs Array of new docs to be processed.
 * @param existingDocs Array of existing docs. Defaults to empty array.
 * @returns The array of new docs, processed where necessary to avoid file name conflicts.
 */
const renameDuplicateFileNames = (newDocs, existingDocs = []) => {
    const mapFileNamesToFirstIndex = (docs) => {
        // key = file name, value = array index of first instance of file name
        const map = new Map();
        docs.forEach(({ fileName }, index) => {
            if (!map.has(fileName))
                map.set(fileName, index);
        });
        return map;
    };
    const appendSuffixToFileName = (fileName, suffix) => {
        // File name includes file extension (if any).
        // Split into parts to append the suffix to the part before the extension.
        const parts = fileName.split(".");
        const indexToModify = parts.length > 1 ? parts.length - 2 : 0;
        parts[indexToModify] += suffix;
        return parts.join(".");
    };
    const existingDocsMap = mapFileNamesToFirstIndex(existingDocs);
    const newDocsMap = mapFileNamesToFirstIndex(newDocs);
    // Iterate through new docs and rename doc if any PRIOR doc has the same file name & extension.
    newDocs.forEach((doc, index) => {
        // The keys in newDocsMap are from the fileName property of each doc in newDocs,
        // so newDocsMap.get(doc.fileName) won't be undefined.
        if (!existingDocsMap.has(doc.fileName) && index === newDocsMap.get(doc.fileName))
            return;
        let count = 0;
        let newFileName;
        // Ensure that the new name does not conflict with the name of ANY doc.
        do {
            count++;
            newFileName = appendSuffixToFileName(doc.fileName, `_${count}`);
        } while (existingDocsMap.has(newFileName) || newDocsMap.has(newFileName));
        newDocsMap.set(newFileName, index);
        doc.fileName = newFileName;
    });
};
exports.renameDuplicateFileNames = renameDuplicateFileNames;
//# sourceMappingURL=rename-duplicate-file-names.js.map